import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import Problem from './sections/Problem';
import PlatformOverview from './sections/PlatformOverview';
import HowItWorks from './sections/HowItWorks';
import Features from './sections/Features';
import Security from './sections/Security';
import UseCases from './sections/UseCases';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Basic smooth scroll implementation for anchors
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <PlatformOverview />
        <HowItWorks />
        <Features />
        <Security />
        <UseCases />
      </main>
      <Footer />
    </div>
  );
}

export default App;
